import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  createTheme,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

import NavigateBeforeRoundedIcon from "@mui/icons-material/NavigateBeforeRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import Header from "../../../Component/content-component/Header";
import Second from "./Second";
import PostEnrollmentForm from "./PostEnrollmentForm";

import "../../../globle.css";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const dottedline = imageBaseUrl + "dottedline.svg";
const service1 = imageBaseUrl + "service1.svg";
const service2 = imageBaseUrl + "service2.svg";
const service3 = imageBaseUrl + "service3.svg";
const service4 = imageBaseUrl + "service4.svg";
const service11 = imageBaseUrl + "service11.svg";
const service22 = imageBaseUrl + "service22.svg";
const service33 = imageBaseUrl + "service33.svg";
const service44 = imageBaseUrl + "service44.svg";

const Abroad = () => {
  const [searchParams] = useSearchParams();
  const urlCategory = searchParams.get("category");
  const urlStatus = searchParams.get("status");

  const theme = useTheme();
  const navigate = useNavigate();
  const [hoveredStep, setHoveredStep] = useState(null);
  const [popup, setPopup] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(urlCategory || null);
  const [categoryAbout, setCategoryAbout] = useState({
    title: "",
    actionType: "",
    category: "",
  });

  const handleBack = () => navigate("/dashboard/admission");

  const FirstCardData = [
    {
      title: "Personalized Mentoring ",
      text: 1,
      icon: service11,
      defaultIcon: service1,
      category: "personalized",
    },
    {
      title: "Career Mapping",
      text: 2,
      icon: service22,
      defaultIcon: service2,
      category: "career",
    },
    {
      title: "Admission Service",
      text: 3,
      icon: service33,
      defaultIcon: service3,
      category: "admission",
    },
    {
      title: "Post Enrollment Support",
      text: 4,
      icon: service44,
      defaultIcon: service4,
      category: "post",
    },
  ];

  const screenBreakpoints = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1600,
        s1: 960,
        s2: 1136,
      },
    },
  });

  const xsFor = useMediaQuery(
    screenBreakpoints.breakpoints.between("xs", "sm"),
  );
  const smFor = useMediaQuery(
    screenBreakpoints.breakpoints.between("sm", "md"),
  );
  const specialScreenFor = useMediaQuery(
    screenBreakpoints.breakpoints.between("s1", "s2"),
  );

  const handleButtonClick = (category) => {
    navigate(`/dashboard/studyabroad?category=${category}`);
    setSelectedCategory((prev) => (prev === category ? null : category));
  };

  return (
    <Box sx={{ backgroundColor: "#FFFFFF", py: 6 }}>
      {/* Back Button */}
      <Button
        onClick={handleBack}
        variant="contained"
        startIcon={<NavigateBeforeRoundedIcon fontSize="small" />}
        sx={{
          backgroundColor: "#00999E",
          color: "#ffffff",
          "&:hover": {
            color: "#00999E",
            backgroundColor: "#f0f0f0",
          },
          fontWeight: 600,
          borderRadius: "5px",
          mt: 2,
          ml: 2,
        }}
      >
        Back
      </Button>

      {/* Header */}
      <Header
        color="#00999e"
        textAlign="center"
        content="Track Your Study Abroad Journey"
      />

      {/* Cards Grid */}
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={3} justifyContent="center">
          {FirstCardData?.map((item, index) => {
            const isActive =
              selectedCategory === item.category || hoveredStep === item.text;

            return (
              <Grid item xs={12} sm={6} md={3} key={index} textAlign="center">
                <Box
                  sx={{
                    borderRadius: "50%",
                    color: "#00999e",
                    right: { xs: "10%", sm: "20%", md: "10%", lg: "10%" },
                    top: {
                      xs: "-6%",
                      sm: "" - (6 % ""),
                      md: "-5%",
                      lg: "-5%",
                    },
                    zIndex: 9,
                  }}
                ></Box>
                <Card
                  onMouseEnter={() => setHoveredStep(item.text)}
                  onMouseLeave={() => setHoveredStep(null)}
                  sx={{
                    height: 200,
                    width: 250,
                    marginBottom: 2,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    border: "",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: isActive ? "#00999E" : "#fff",
                    color: isActive ? "#fff" : "#000",
                    textAlign: "center",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                    transition: "0.3s",
                    p: 2,
                  }}
                  className="pseudo-partial-border"
                >
                  {/* Top-Right Badge */}
                  <Paper
                    elevation={3}
                    sx={{
                      height: 30,
                      width: 30,
                      position: "absolute",
                      top: 10,
                      right: 10,
                      borderRadius: "50%",
                      backgroundColor: isActive ? "#00999E" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color={isActive ? "#fff" : "#00999E"}
                    >
                      {item?.text}
                    </Typography>
                  </Paper>

                  {/* Icon */}
                  <img
                    src={isActive ? item?.icon : item?.defaultIcon}
                    alt={item?.title}
                    style={{ height: 50, marginBottom: 16 }}
                  />

                  {/* Title */}
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ mb: 2, px: 1 }}
                  >
                    {item?.title}
                  </Typography>
                </Card>

                {/* Button */}
                <Button
                  onClick={() => handleButtonClick(item?.category)}
                  variant="contained"
                  endIcon={
                    selectedCategory === item?.category ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  }
                  sx={{
                    backgroundColor: "#00999E",
                    "&:hover": {
                      backgroundColor: "#007f80",
                    },
                  }}
                >
                  View More
                </Button>
              </Grid>
            );
          })}
        </Grid>

        {/* Dotted Line and Content Below Cards */}
        {selectedCategory && (
          <Box mt={6}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              mb={3}
            >
              <img src={dottedline} alt="dotted-line" height={80} />
              <KeyboardArrowDownIcon sx={{ color: "#00999E", fontSize: 28 }} />
            </Box>

            {selectedCategory === "post" ? (
              <PostEnrollmentForm />
            ) : (
              <Second
                theme={theme}
                popup={popup}
                setPopup={setPopup}
                categoryAbout={categoryAbout}
                setCategoryAbout={setCategoryAbout}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                isSmallScreen={xsFor || smFor || specialScreenFor}
                urlStatus={urlStatus}
              />
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Abroad;
